import { render, staticRenderFns } from "./registerSteps.vue?vue&type=template&id=fadac788"
import script from "./registerSteps.vue?vue&type=script&lang=js"
export * from "./registerSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports